import * as React from 'react';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var isValidElement$2 = React.isValidElement, cloneElement = React.cloneElement;
function rebuildElement(parent, children) {
    if (!children) {
        return parent;
    }
    if (Array.isArray(children)) {
        children = children.map(function (e, i) {
            return isValidElement$2(e) ?
                cloneElement(e, __assign(__assign({}, e.props), { key: i })) :
                e;
        });
    }
    if (!parent || Array.isArray(parent)) {
        return children;
    }
    if (isValidElement$2(parent)) {
        return cloneElement(parent, __assign(__assign({}, parent.props), { children: children }));
    }
    return parent;
}

var isValidElement$1 = React.isValidElement;
function traverseElementTree(node, visitor, state) {
    function visit(target, children) {
        return visitor.visit(target, state, children);
    }
    function traverse(target, newState) {
        return traverseElementTree(target, visitor, newState || state);
    }
    if (isValidElement$1(node)) {
        if (typeof node.type === "function") {
            if ('prototype' in node.type && node.type.prototype.isReactComponent) {
                node = new node.type(node.props).render();
            }
            else {
                node = node.type(node.props);
            }
            return traverse(node);
        }
        else if (node.props && 'children' in node.props) {
            var children_1 = node.props['children'];
            var traverseChildren = function (newState) {
                return Array.isArray(children_1) ?
                    children_1.map(function (child) {
                        return traverse(child, newState);
                    }) :
                    traverse(children_1, newState);
            };
            return visit(node, traverseChildren);
        }
    }
    else if (Array.isArray(node)) {
        var nodeArray_1 = node;
        var traverseChildren = function (newState) {
            return nodeArray_1.map(function (item) { return traverse(item, newState); });
        };
        return visit(node, traverseChildren);
    }
    return visit(node);
}

var isValidElement = React.isValidElement;
function replaceInTree(node, args) {
    var match;
    var replace = args.replace, updateState = args.updateState;
    if ("matchElement" in args) {
        match = function (i) { return isValidElement(i) && i.type === args.matchElement; };
    }
    else if ("matchLiteral" in args) {
        match = function (i) {
            return !Array.isArray(i) && !isValidElement(i) && args.matchLiteral(i);
        };
    }
    else {
        match = args.match;
    }
    return traverseElementTree(node, {
        visit: function (element, state, children) {
            var newState = updateState ? updateState(element, state) : state;
            var resolvedChildren = children ? children(newState) : undefined;
            var result = rebuildElement(element, resolvedChildren);
            if (match(result, newState)) {
                return replace(result, newState);
            }
            else {
                return result;
            }
        }
    }, args.initialState);
}

function Replacer(props) {
    return React.createElement(React.Fragment, null, replaceInTree(props.children, props));
}

export { Replacer, rebuildElement, replaceInTree, traverseElementTree };
//# sourceMappingURL=index.es.js.map
